<div id="arrow-container">
    <img id="arrow" class="glow" src="img/next-section-arrow.png" alt="Arrow pointing right">
</div>
